var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFmsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 43.1",
    style: {
      enableBackground: "new 0 0 300 43.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Outline_",
    className: "st0",
    d: "M109.7,24.3H86.8v3.6h22.7c0.9,0,1.3-0.3,1.3-1v-1.6C110.9,24.3,109.7,24.3,109.7,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Outline_2",
    className: "st0",
    d: "M109.6,15.2H86.8v3.6h23c0.2,0,1.1,0,1.1-0.7v-1.9C110.9,15.5,110.5,15.2,109.6,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compounded_outline_",
    className: "st0",
    d: "M233.4,0h-223C4.6,0,0,4.6,0,10.4c0,0,0,0,0,0v32.7h223c5.7,0,10.4-4.6,10.4-10.4v0 L233.4,0L233.4,0z M42.6,15.2H16.8c-0.9,0-1.3,0.4-1.3,1.2v2.4h26.9v5.5H15.5v9.1H9.7V15.5c0-3.2,2.6-5.8,5.8-5.8c0,0,0,0,0,0h27.1 V15.2z M78.4,15.2H51v3.6h27.4v5.5H51v3.6h27.4v5.5H45.2V9.7h33.2V15.2z M116.9,17.6c0,1.5-1.1,2.7-2.4,3.6 c1.4,0.5,2.3,1.8,2.3,3.3v3.1c0,3.9-2.4,5.8-7.1,5.8H81.1V9.7h28.6c4.6,0,7.3,1.9,7.3,5.8L116.9,17.6z M152.5,15.2h-27.4v3.6h27.4 v5.5h-27.4v3.6h27.4v5.5h-33.3V9.7h33.2L152.5,15.2z M187.8,27.6c0,3.8-2.4,5.8-7.1,5.8h-25.5v-5.5h25.5c0.9,0,1.3-0.3,1.3-0.8 v-1.9c0-0.6-0.4-0.9-1.3-0.9h-18.4c-4.8,0-7.2-1.7-7.1-5.1v-3.7c0-3.9,2.4-5.8,7.2-5.8h25.5v5.5h-25.5c-0.9,0-1.4,0.3-1.4,0.9v1.8 c0,0.6,0.5,0.9,1.4,0.9h18.4c4.7,0,7.1,1.9,7.1,5.7L187.8,27.6z M223.7,15.2h-13.6v18.2h-5.8V15.2h-13.9V9.7h33.3L223.7,15.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.9,9.2c1.6,0,2.3,0.8,2.4,2.4l0.9,21.9h-6l-0.8-19.2h-0.6l-2.9,13.6c-0.2,1.3-1.1,2-2.5,2h-3.7 c-1.4,0-2.3-0.7-2.6-2l-3-13.6h-0.6L254,33.4h-6l0.8-21.9c0.1-1.5,0.8-2.4,2.4-2.4h5.8c1.4,0,2.3,0.7,2.5,2.1l2.3,10.8 c0.2,1.2,0.3,2.4,0.5,3.5h0.4c0.2-1.2,0.3-2.4,0.5-3.5l2.2-10.7c0.3-1.4,1.1-2.1,2.5-2.1H273.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.3,9.8l-0.4,4.3c-2.1,0-5.2-0.1-8-0.1c-2.1,0-2.8,0.2-2.8,1.5c0,1.1,0.6,1.5,2.3,2.1l4.4,1.7 c3.9,1.6,5.3,3.7,5.3,7.3c0,5.5-2.3,7.2-9.4,7.2c-1.6,0-4.9-0.1-8.8-1.1l0.4-4.7c4.3,0.1,7,0.2,8.4,0.2c2.3,0,2.9-0.3,2.9-1.5 c0-1.2-0.5-1.5-1.9-2l-4.8-1.9c-3.8-1.5-5.2-3.6-5.2-7.2c0-5.6,2.6-6.9,9.4-6.9C293.4,8.7,296.5,8.9,299.3,9.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmsLogo);
export default __webpack_public_path__ + "static/media/fms_logo.fa76c1c2b4f2c67dd3d8e6038d28601d.svg";
export { ForwardRef as ReactComponent };